import styled from 'styled-components';

export default styled.svg.attrs({
  preserveAspectRatio: 'xMidYMid meet',
  xmlns: 'http://www.w3.org/2000/svg'
})``;
